require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/fn/object/keys.js
// module id = ./node_modules/babel-runtime/node_modules/core-js/library/fn/object/keys.js
// module chunks = 0